import Alert from '@mui/material/Alert'
import Snackbar, { SnackbarProps, SnackbarOrigin } from '@mui/material/Snackbar'

import { SmallKnight } from 'components/Icons/SvgIcon'

const anchor: SnackbarOrigin = { vertical: 'bottom', horizontal: 'right' }
const alertStyle = {
  outline: '1px solid black',
  alignItems: 'center',
  pl: 1,
  pr: 3,
  py: 0,

  '.MuiAlert-message': {
    display: 'flex',
    alignItems: 'center',
  }
}
export default function ErrorMessage({ children, onClose, ...props }: SnackbarProps) {
  return (
    <Snackbar
      anchorOrigin={anchor}
      onClose={onClose}
      autoHideDuration={5000}
      {...props}
    >
      <Alert
        variant="filled"
        severity="error"
        icon={false}
        sx={alertStyle}
        onClose={onClose as () => void}
      >
        <SmallKnight width={48} style={{ marginRight: 10 }} />
        <p>{ children }</p>
      </Alert>
    </Snackbar>
  )
}
